module.exports = __webpack_public_path__ + "static/media/logo2.b8558180.png";